export default {"src":"/statics/ecommerce/_next/static/media/byou.75a4dfa2.svg","height":14,"width":49,"blurWidth":0,"blurHeight":0};